// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { ComparateurFacturesService } from "./comparateur-factures.service"
import { CourtageService } from "./courtage.service"
import { FacturesEspaceService } from "./factures-espace.service"
import { OptimTurpeService } from "./optim-turpe.service"
import { OptimTurpeV2Service } from "./optim-turpe-v2.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./comparateur-factures.service"
export * from "./courtage.service"
export * from "./factures-espace.service"
export * from "./optim-turpe.service"
export * from "./optim-turpe-v2.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const courtageServiceRegistry = {
    comparateurFactures: new ComparateurFacturesService(),
    courtage: new CourtageService(),
    facturesEspace: new FacturesEspaceService(),
    optimTurpe: new OptimTurpeService(),
    optimTurpeV2: new OptimTurpeV2Service(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type CourtageServiceRegistry = typeof courtageServiceRegistry
